import { SECOND_PILLOW_ENABLED_FLAG, SECOND_PILLOW_UNTIL, THREE_PLUS_ENABLED_FLAG, THREE_PLUS_UNTIL } from './config';

export function parseDateYMD(source: string) {
    const parts = source.split('-').map(Number);
    if (parts.length !== 3) return null;
    const [y, m, d] = parts;
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
    if (m < 1 || m > 12 || d < 1 || d > 31) return null;
    return { y, m, d };
}

export function isSeasonalThreePlusActive(now: Date = new Date()): boolean {
    if (!THREE_PLUS_ENABLED_FLAG) return false;
    if (!THREE_PLUS_UNTIL) return true;
    const parsed = parseDateYMD(THREE_PLUS_UNTIL);
    if (!parsed) return false;
    const { y, m, d } = parsed;
    const cy = now.getFullYear();
    const cm = now.getMonth() + 1;
    const cd = now.getDate();
    if (cy > y) return false;
    if (cy === y && cm > m) return false;
    if (cy === y && cm === m && cd > d) return false;
    return true;
}

export function isSeasonalSecondPillowActive(now: Date = new Date()): boolean {
    if (!SECOND_PILLOW_ENABLED_FLAG) return false;
    if (!SECOND_PILLOW_UNTIL) return true;
    const parsed = parseDateYMD(SECOND_PILLOW_UNTIL);
    if (!parsed) return false;
    const { y, m, d } = parsed;
    const cy = now.getFullYear();
    const cm = now.getMonth() + 1;
    const cd = now.getDate();
    if (cy > y) return false;
    if (cy === y && cm > m) return false;
    if (cy === y && cm === m && cd > d) return false;
    return true;
}
